import { useState, useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";
import HeroSection from "@/components/sections/HeroSection";
import AboutSection from "@/components/sections/AboutSection";
import MethodSection from "@/components/sections/MethodSection";
import VisualProofSection from "@/components/sections/VisualProofSection";
import PackagesSection from "@/components/sections/PackagesSection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import NewsletterSection from "@/components/sections/NewsletterSection";
import ApplicationSection from "@/components/sections/ApplicationSection";
import InstagramSection from "@/components/sections/InstagramSection";
import Footer from "@/components/sections/Footer";
import VenmoModal from "@/components/VenmoModal";
import Navigation from "@/components/Navigation";

export default function HomePage() {
  const [venmoOpen, setVenmoOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const handlePayment = (packageInfo) => {
    setSelectedPackage(packageInfo);
    setVenmoOpen(true);
  };

  return (
    <main className="min-h-screen bg-[#0a0a0a]">
      <Navigation />
      
      <HeroSection />
      
      <AboutSection />
      
      <MethodSection />
      
      <VisualProofSection />
      
      <PackagesSection onPayment={handlePayment} />
      
      <TestimonialsSection />
      
      <NewsletterSection />
      
      <ApplicationSection />
      
      <InstagramSection />
      
      <Footer />
      
      <VenmoModal 
        open={venmoOpen} 
        onOpenChange={setVenmoOpen}
        packageInfo={selectedPackage}
      />
    </main>
  );
}
